import { render, staticRenderFns } from "./VaultManageView.vue?vue&type=template&id=610c3ab0&scoped=true&"
import script from "./VaultManageView.vue?vue&type=script&lang=ts&"
export * from "./VaultManageView.vue?vue&type=script&lang=ts&"
import style0 from "./VaultManageView.vue?vue&type=style&index=0&id=610c3ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c3ab0",
  null
  
)

export default component.exports